import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SYSTEM_CODE } from '@constants/app.constant';
import { AirCraftModel } from '@models/air-craft.model';
import { BaseResponseModel, ResponseModel } from '@models/app.model';
import {
    AddInfantRequestModel,
    BookingContactRequest,
    BookingHistoryModel,
    BookingHistoryReq,
    BookingManagementRequest,
    BookingManagementResponse,
    BookingOrderModel,
    BookingPaymentRequest,
    BookingStatusCurrent,
    BookingStatusCurrentParam,
    CancelBookingRequest,
    ChangeAncillaryRequest,
    ChangeCustomerName,
    ChangeSeatRequest,
    CheckChangeCustomerNameRes,
    CheckPriceChangeBookingRes,
    CheckPriceRequest,
    CheckPriceResponse,
    DeleteCommentReq,
    DocumentCustomerRequest,
    FareRuleMapKeyRes,
    SearchFlightResponse,
    RefundTicketReq,
    ResendEmailRequest,
    SearchListFareRuleMapKeyRq,
    SplitTicketRequest,
    SplitTicketResponse,
    SyncBookingRequest,
    SyncBookingResponse,
    UpdateCustomerInfoReq,
    VoidTicketRequest,
    AddOSIReq,
    AddRemarkReq,
    AddSKReq,
    AddMembershipReq,
    ChangeCustomerBirthday,
} from '@models/booking.model';
import { BaggageResponse, BaggagesChangeRequest, ChangeFlightRequest, CreateBookingResponse, SearchFlightReplaceReq, SeatMapChangeRequest, SeatMapResponse } from '@models/flight.model';
import { HttpService } from '@services/http.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class BookingService {
    constructor(private httpService: HttpService) {}

    public getBookingManagement(
        reqParams: BookingManagementRequest
    ): Observable<BaseResponseModel<BookingManagementResponse[]>> {
        return this.httpService.get('Booking/SearchListBooking', {
            params: new HttpParams({ fromObject: { ...reqParams } }),
        });
    }

    public getDetailBooking(
        transactionId: string
    ): Observable<BaseResponseModel<BookingOrderModel>> {
        return this.httpService.get('Booking/BookingDetail', {
            params: new HttpParams({ fromObject: { code: transactionId } }),
        });
    }

    public getBookingHistory(key: string): Observable<BookingHistoryModel[]> {
        return this.httpService.get('Booking/BookingHistory', {
            params: new HttpParams({ fromObject: { key } }),
        });
    }

    public cancelBooking(reqBody: CancelBookingRequest): Observable<ResponseModel> {
        return this.httpService.post('Booking/CancelBooking', reqBody, { updateLoading: true });
    }

    public syncBooking(reqBody: SyncBookingRequest): Observable<BaseResponseModel<SyncBookingResponse>> {
        return this.httpService.post('Booking/SyncBooking', reqBody, { updateLoading: true });
    }

    public sendComment(body: BookingHistoryReq): Observable<ResponseModel> {
        return this.httpService.post('Booking/SendComment', body);
    }

    public deleteComment(body: DeleteCommentReq): Observable<ResponseModel> {
        return this.httpService.post('Booking/ChangeStatusRemarkLog', body);
    }

    public changeSeat(reqBody: ChangeSeatRequest): Observable<ResponseModel> {
        return this.httpService.post('Booking/ChangeSeat', reqBody, {
            updateLoading: true,
        });
    }

    public bookingPayment(reqBody: BookingPaymentRequest): Observable<ResponseModel> {
        return this.httpService.post('Booking/BookingPayment', reqBody, {
            updateLoading: true,
        });
    }

    public changeContact(reqBody: BookingContactRequest): Observable<BaseResponseModel<ResponseModel>> {
        return this.httpService.post('Booking/ChangeContact', reqBody, {
            updateLoading: true,
        });
    }

    public changeAncillary(reqBody: ChangeAncillaryRequest): Observable<BaseResponseModel<ResponseModel>> {
        return this.httpService.post('Booking/ChangeAncillary', reqBody);
    }

    public changeDocumentCustomer(reqBody: DocumentCustomerRequest): Observable<ResponseModel> {
        return this.httpService.post('Booking/ChangeDocument', reqBody);
    }

    public checkAddInfant(reqBody: AddInfantRequestModel): Observable<BaseResponseModel<CheckChangeCustomerNameRes>> {
        return this.httpService.post('Booking/CheckAddInfant', reqBody, {
            updateLoading: true,
        });
    }

    public addInfant(reqBody: AddInfantRequestModel): Observable<ResponseModel> {
        return this.httpService.post('Booking/AddInfant', reqBody);
    }

    public checkChangePassengerName(reqBody: ChangeCustomerName): Observable<BaseResponseModel<CheckChangeCustomerNameRes>> {
        return this.httpService.post('Booking/CheckPriceChangeCustomerName', reqBody, {
            updateLoading: true,
        });
    }

    public changeCustomerName(reqBody: ChangeCustomerName): Observable<ResponseModel> {
        return this.httpService.post('Booking/ChangePassengerName', reqBody, {
            updateLoading: true,
        });
    }

    public changeCustomerInfo(reqBody: UpdateCustomerInfoReq): Observable<ResponseModel> {
        return this.httpService.post('Booking/ChangeCustomerInfo', reqBody, {
            updateLoading: true,
        });
    }

    public getSeatMapsChange(reqBody: SeatMapChangeRequest): Observable<BaseResponseModel<SeatMapResponse[]>> {
        return this.httpService.post('Seat/GetSeatMapsChange', reqBody, {
            updateLoading: true,
        });
    }

    public getBaggageChange(reqBody: BaggagesChangeRequest): Observable<BaseResponseModel<BaggageResponse[]>> {
        return this.httpService.post('Service/GetBaggageChange', reqBody, {
            updateLoading: true,
        });
    }

    public getServicesChange(reqBody: BaggagesChangeRequest): Observable<BaseResponseModel<BaggageResponse[]>> {
        return this.httpService.post('Service/GetAncillaryChange', reqBody, {
            updateLoading: true,
        });
    }

    public searchListFareRuleMapKey(
        req: SearchListFareRuleMapKeyRq[]
    ): Observable<BaseResponseModel<FareRuleMapKeyRes[]>> {
        return this.httpService.post('MasterData/SearchListFareRuleMapKey', req);
    }

    public getAllAircraft(): Observable<BaseResponseModel<AirCraftModel[]>> {
        return this.httpService.get('MasterData/GetAirCraft');
    }

    public getBookingStatusCurrent(
        param: BookingStatusCurrentParam
    ): Observable<BaseResponseModel<BookingStatusCurrent>> {
        return this.httpService.post('Booking/GetBookingStatus', param);
    }

    public checkChangeFlight(reqBody: ChangeFlightRequest): Observable<BaseResponseModel<CheckPriceChangeBookingRes>> {
        return this.httpService.post('Booking/CheckPriceChangeFlight', reqBody, {
            updateLoading: true,
        });
    }

    public checkAddFlight(reqBody: ChangeFlightRequest): Observable<BaseResponseModel<CheckPriceChangeBookingRes>> {
        return this.httpService.post('Booking/CheckPriceAddFlight', reqBody, {
            updateLoading: true,
        });
    }

    public addFlight(reqBody: ChangeFlightRequest): Observable<BaseResponseModel<CreateBookingResponse>> {
        return this.httpService.post('Booking/AddFlight', reqBody, { updateLoading: true });
    }

    public searchFlightReplace(
        reqBody: SearchFlightReplaceReq
    ): Observable<BaseResponseModel<SearchFlightResponse[]>> {
        return this.httpService.post('Flight/SearchChange', reqBody);
    }

    public changeFlight(reqBody: ChangeFlightRequest, isReservationStatus = false): Observable<BaseResponseModel<CreateBookingResponse>> {
        let endpoint = 'Booking/ChangeFlight';
        if (reqBody.SystemCode === SYSTEM_CODE.VNA && isReservationStatus) {
            endpoint = 'Booking/ChangeFlightVN';
        }
        return this.httpService.post(endpoint, reqBody, { updateLoading: true });
    }

    public voidTicket(reqBody: VoidTicketRequest): Observable<ResponseModel> {
        return this.httpService.post('Booking/VoidTicket', reqBody);
    }

    public splitTicket(reqBody: SplitTicketRequest): Observable<BaseResponseModel<SplitTicketResponse>> {
        return this.httpService.post('Booking/SplitTicket', reqBody);
    }

    public refundBooking(reqBody: RefundTicketReq): Observable<ResponseModel> {
        return this.httpService.post('Booking/RefundBooking', reqBody);
    }
    
    public resendEmail(reqBody: ResendEmailRequest): Observable<ResponseModel> {
        return this.httpService.post('Booking/ResendEmail', reqBody);
    }

    public addOSI(reqBody: AddOSIReq): Observable<ResponseModel> {
        return this.httpService.post('Booking/AddOSI', reqBody, { updateLoading: true });
    }

    public addRemark(reqBody: AddRemarkReq): Observable<ResponseModel> {
        return this.httpService.post('Booking/AddRemark', reqBody, { updateLoading: true });
    }

    public addSK(reqBody: AddSKReq): Observable<ResponseModel> {
        return this.httpService.post('Booking/AddSK', reqBody, { updateLoading: true });
    }

    public addMembership(reqBody: AddMembershipReq): Observable<ResponseModel> {
        return this.httpService.post('Booking/AddMembership', reqBody, { updateLoading: true });
    }

    public removeFlight(reqBody: ChangeFlightRequest): Observable<SplitTicketResponse> {
        return this.httpService.post('Booking/RemoveFlight', reqBody, { updateLoading: true });
    }

    public changeCustomerBirthday(
        reqBody: ChangeCustomerBirthday
    ): Observable<ResponseModel> {
        return this.httpService.post('Booking/UpdateBirthdayCustomer', reqBody, {
            updateLoading: true,
        });
    }
}
